import { BETA_BADGE_LABEL } from './constants';
import { BadgedRoutes, NavDataItemWithChildren } from './types';
import iconAgentQa from 'src/assets/images/icon-agent-qa.svg';
import iconAssist from 'src/assets/images/icon-assist.svg';
import iconDiscover from 'src/assets/images/icon-discover.svg';
import iconOrchestrator from 'src/assets/images/icon-orchestrator.svg';
import iconSettings from 'src/assets/images/icon-settings.svg';
import iconSolve from 'src/assets/images/icon-solve.svg';
import iconTriage from 'src/assets/images/icon-triage.svg';
import {
  ROUTE_ACCOUNT_SETTINGS,
  ROUTE_ACTION_BUILDER,
  ROUTE_AGENT_QA_INSIGHTS,
  ROUTE_AGENT_QA_SETUP,
  ROUTE_AI_QA,
  ROUTE_ASSIST_CONFIGURATION,
  ROUTE_ASSIST_INSIGHTS,
  ROUTE_ASSIST_NOTES,
  ROUTE_ASSIST_WORKFLOW_BUILDER,
  ROUTE_DISCOVER_AUTOMATION,
  ROUTE_DISCOVER_INSIGHTS,
  ROUTE_INTEGRATIONS,
  ROUTE_KNOWLEDGE,
  ROUTE_LOG,
  ROUTE_ORCHESTRATOR,
  ROUTE_PLAN_PAGE,
  ROUTE_PREDICT_INTENTS,
  ROUTE_PREDICTION_SETTINGS,
  ROUTE_SECURITY,
  ROUTE_SOLVE,
  ROUTE_SOLVE_CONFIGURATION,
  ROUTE_SOLVE_INSIGHTS_MAIN,
  ROUTE_SOLVE_LITE,
  ROUTE_SOLVE_TESTS,
  ROUTE_SSO_SETTINGS,
  ROUTE_TEAM,
  ROUTE_TRIAGE_INSIGHTS,
  ROUTE_TRIAGE_SIMULATIONS,
  ROUTE_WORKFLOW_BUILDER,
} from 'src/components/app/routes/routeDefinitions';
import { Tabs } from 'src/utils/enums';

// True means the route will be shown to the user as new
export const initialBadgedRoutes: BadgedRoutes = {};

const navData: NavDataItemWithChildren[] = [
  {
    children: [
      {
        name: Tabs.DISCOVER_INSIGHTS,
        route: ROUTE_DISCOVER_INSIGHTS,
      },
      {
        name: Tabs.DISCOVER_AUTOMATION,
        route: ROUTE_DISCOVER_AUTOMATION,
      },
    ],
    icon: iconDiscover,
    name: Tabs.DISCOVER,
  },
  {
    children: [
      {
        name: Tabs.SOLVE_INSIGHT,
        route: ROUTE_SOLVE_INSIGHTS_MAIN,
      },
      {
        name: Tabs.SOLVE_DASHBOARD,
        route: ROUTE_SOLVE,
      },
      {
        name: Tabs.WORKFLOW_BUILDER,
        route: ROUTE_WORKFLOW_BUILDER,
      },
      {
        badgeLabel: BETA_BADGE_LABEL,
        name: Tabs.SIMULATIONS,
        route: ROUTE_PREDICT_INTENTS,
      },
      { name: Tabs.KNOWLEDGE, route: ROUTE_KNOWLEDGE },
      {
        name: Tabs.ACTION_BUILDER,
        route: ROUTE_ACTION_BUILDER,
      },
      {
        name: Tabs.SOLVE_CONFIGURATION,
        route: ROUTE_SOLVE_CONFIGURATION,
      },
      {
        name: Tabs.AI_QA,
        route: ROUTE_AI_QA,
      },
      {
        name: Tabs.SOLVE_TESTS,
        route: ROUTE_SOLVE_TESTS,
      },
    ],
    icon: iconSolve,
    name: Tabs.SOLVE,
  },

  {
    icon: iconSolve,
    name: Tabs.SOLVE_LITE,
    route: ROUTE_SOLVE_LITE,
  },
  {
    children: [
      {
        name: Tabs.TRIAGE_INSIGHTS,
        route: ROUTE_TRIAGE_INSIGHTS,
      },
      {
        name: Tabs.PREDICTIONS_SETTINGS,
        route: ROUTE_PREDICTION_SETTINGS,
      },
      {
        name: Tabs.SIMULATION_RUNS,
        route: ROUTE_TRIAGE_SIMULATIONS,
      },
    ],
    icon: iconTriage,
    name: Tabs.PREDICTIONS,
  },
  {
    children: [
      { name: Tabs.AGENT_QA_INSIGHTS, route: ROUTE_AGENT_QA_INSIGHTS },
      { name: Tabs.AGENT_QA_SETUP, route: ROUTE_AGENT_QA_SETUP },
    ],
    icon: iconAgentQa,
    name: Tabs.AGENT_QA,
  },
  {
    children: [
      {
        name: Tabs.ASSIST_INSIGHTS,
        route: ROUTE_ASSIST_INSIGHTS,
      },
      {
        name: Tabs.WORKFLOW_BUILDER,
        route: ROUTE_ASSIST_WORKFLOW_BUILDER,
      },
      {
        name: Tabs.SOLVE_CONFIGURATION,
        route: ROUTE_ASSIST_CONFIGURATION,
      },
      {
        name: Tabs.ASSIST_NOTES,
        route: ROUTE_ASSIST_NOTES,
      },
    ],
    icon: iconAssist,
    name: Tabs.ANSWERS,
  },
  {
    icon: iconOrchestrator,
    name: Tabs.ORCHESTRATOR,
    route: ROUTE_ORCHESTRATOR,
  },
  {
    children: [
      { name: Tabs.PLAN, route: ROUTE_PLAN_PAGE },
      {
        name: Tabs.SECURITY,
        route: ROUTE_SECURITY,
      },
      {
        name: Tabs.ACCOUNT_SETTINGS,
        route: ROUTE_ACCOUNT_SETTINGS,
      },
      {
        name: Tabs.INTEGRATIONS,
        route: ROUTE_INTEGRATIONS,
      },
      {
        name: Tabs.TEAM,
        route: ROUTE_TEAM,
      },

      {
        name: Tabs.LOG,
        route: ROUTE_LOG,
      },

      {
        name: Tabs.SSO_SETTINGS,
        route: ROUTE_SSO_SETTINGS,
      },
    ],
    icon: iconSettings,
    name: Tabs.SETTINGS,
  },
];

export default navData;
